import { FormEventHandler } from "react";
import { OnboardingFormCardContainer } from "../containers/onboarding-form-card-container";
import { OnboardingPageContainer } from "../containers/onboarding-page-container";
import { OnboardingFadeContent } from "../onboarding-fade-content";
import { TitleSlogan } from "../title-slogan";

interface AnimatedOnboardingContainerProps {
  pageRef?: React.RefObject<HTMLElement>;
  children: React.ReactNode;
  title: string;
  handleSubmit?: FormEventHandler<HTMLFormElement>;
  classNames?: {
    container?: string;
    image?: string;
    form?: string;
  };
}

export const AnimatedOnboardingContainer = ({
  pageRef,
  children,
  title,
  handleSubmit,
  classNames,
}: AnimatedOnboardingContainerProps) => {
  return (
    <OnboardingPageContainer pageRef={pageRef} backgroundColorClassName="bg-white" color="white">
      <OnboardingFadeContent className="flex h-full w-full flex-1 flex-col items-center gap-4">
        <TitleSlogan slogan={title} />
        <OnboardingFormCardContainer onSubmit={handleSubmit} classNames={classNames}>
          {children}
        </OnboardingFormCardContainer>
      </OnboardingFadeContent>
    </OnboardingPageContainer>
  );
};
